import React from 'react';

const steps = [
  { num: 1, title: "Discovery &\nAnalysis", desc: "Understanding business needs and defining scope" },
  { num: 2, title: "Design", desc: "Creating intuitive user experiences and system architecture" },
  { num: 3, title: "Development", desc: "Building scalable and secure solutions" },
  { num: 4, title: "Testing", desc: "Ensuring performance, reliability, and security" },
  { num: 5, title: "Deployment", desc: "Launching solutions in production environments" },
  { num: 6, title: "Support &\nMaintenance", desc: "Ongoing monitoring and improvements" }
];

const Process = () => {
  return (
    <section className="section process-section" id="process">
      <div className="container">
        <h2>From Vision to Visible</h2>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div className="divider-short"></div>
        </div>
        
        <div className="timeline">
          {steps.map((step) => (
            <div key={step.num} className="timeline-item">
              <div className="timeline-number">{step.num}</div>
              <h4 style={{ whiteSpace: 'pre-line' }}>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
